module.exports = __webpack_public_path__ + "img/Ball-0.9s-200px.c6e7e86a.svg";